<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
    <transition name="bounce">
      <b-container class="py-5 custom-container container">
        <b-breadcrumb
          :items="items"
          class="pl-0 pt-5 mt-5 bg-transparent"
        ></b-breadcrumb>
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">{{ filename }}</h2>
          </b-col>
          <b-col class="text-right align-right">
            <requests-file-options
              v-if="
                request &&
                  (fileStatus === 'not started' || fileStatus === 'rejected')
              "
              :request="request"
              @showAlert="showAlert"
            ></requests-file-options>
          </b-col>
        </b-row>

        <b-row
          v-if="!isEmptyObj(request) && request.file_share"
          class="mx-0 my-2"
        >
          <b-card no-body class="preview">
            <b-img-lazy
              v-bind="mainProps"
              class="image"
              v-if="request"
              :src="fileSrc"
              alt="Image 1"
            ></b-img-lazy>
          </b-card>
        </b-row>
        <b-row class5="mx-0 mt-4">
          <b-col cols="12" sm="12" class="d-flex flex-column">
            <b-container fluid>
              <template v-if="isEmptyObj(request)"></template>
              <b-row
                v-else-if="!isEmptyObj(request) && request.file_share"
                class="preview-container"
              >
                <b-col
                  sm="6"
                  lg="5"
                  class="pl-0"
                  v-for="image in request.file_share.file"
                  :key="image.id"
                >
                  <b-card no-body class="files">
                    <b-img-lazy
                      v-bind="mainProps"
                      class="image"
                      :src="image.thumb_url"
                    ></b-img-lazy>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="mt-auto">
                <b-col
                  v-if="!isEmptyObj(request) && request.file_share"
                  cols="12"
                  sm="12"
                  class="mb-0"
                >
                  <b-card class="mt-4 file-details">
                    <h3 class="my-4 font-weight-bold">
                      File Details
                    </h3>
                    <b-card-body v-if="request" class="pl-0 align-items-center">
                      <b-row
                        class="mb-3"
                        v-for="info in request.information_types"
                        :key="info.id"
                      >
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          {{ info.label }}
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          {{
                            info.value
                              ? info.field_type === 'date'
                                ? parseDate(info.value)
                                : info.value
                              : ''
                          }}
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="12" sm="12" class="mb-0">
                  <b-card class="mt-4 file-details">
                    <h3 class="my-4 font-weight-bold">
                      Request Details
                    </h3>
                    <b-card-body v-if="request" class="pl-0 align-items-center">
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Requested File
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          {{ request.name }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Project
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          {{ request.project }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Due Date
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          {{ parseDate(request.due_date) }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Requested By
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          {{ user.full_name }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Assigned To
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          <!-- {{ request.user.full_name }} -->
                          {{ requestedToNames }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col
                          cols="7"
                          sm="7"
                          md="4"
                          lg="4"
                          class="font-weight-bold"
                        >
                          Instructions
                        </b-col>
                        <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                          <p>{{ request.instruction }}</p>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>

        <b-alert
          class="custom-alert"
          :show="dismissCountDown"
          dismissible
          fade
          variant="primary"
          @dismiss-count-down="countDownChanged"
          >File Request has been {{ alertMsg }}.</b-alert
        >

        <b-alert
          class="custom-alert"
          :show="dismissCountDown"
          :class="{
            'bg-danger border-danger': alertType === 'danger'
          }"
          dismissible
          fade
          :variant="alertType"
          @dismiss-count-down="countDownChanged"
        >
          {{ alertMsg }}
        </b-alert>
      </b-container>
    </transition>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RequestsFileOptions from '@/components/modals/RequestsFileOptions'
import isEmpty from 'lodash'

export default {
  name: 'ViewRequestedToPage',

  components: {
    RequestsFileOptions
  },

  data() {
    return {
      loading: false,
      mainProps: {
        center: true,
        blank: true,
        blankColor: '#bbb'
      },
      checkedFiles: [],
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: '',
      alertType: 'primary'
    }
  },

  computed: {
    ...mapGetters('requests', ['request']),
    ...mapGetters('auth', ['user']),

    filename() {
      return this.request && this.request.file_request
        ? this.request.file_request.name
        : this.request
        ? this.request.name
        : ''
    },

    fileStatus() {
      return this.request
        ? this.request.file_share && this.request.file_share !== null
          ? !this.request.file_share.file
            ? !this.request.file_share.file.status
              ? 'not started'
              : this.request.file_share.file.status
            : 'not started'
          : 'not started'
        : 'not started'
    },

    items() {
      return [
        {
          text: 'File Requests',
          to: '/requests'
        },
        {
          text: this.filename
        }
      ]
    },

    fileSrc() {
      return this.request
        ? this.request.file_share
          ? this.request.file_share.file[0].thumb_url
          : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
        : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
    },

    requestedToNames() {
      if (this.request.user) {
        return this.request.user.full_name
      } else {
        return this.request &&
          (this.request.requested_to || this.request.requested_to.length)
          ? this.request.requested_to
              .map(e => {
                return e.full_name
              })
              .join(', ')
          : ''
      }
    }
  },

  methods: {
    ...mapActions({
      getRequestByUser: 'requests/getRequestByUser',
      getRequest: 'requests/getRequest'
    }),

    async fetchRequest() {
      this.loading = true

      await this.getRequest(this.$route.params.id)
        .catch(err => {
          if (err.status === 404) {
            this.$router.replace({
              name: 'page-not-found'
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    showAlert(action) {
      this.dismissCountDown = 1
      this.alertMsg = `Request File has been ${{ action }}.`

      if (action === 'deleted') {
        this.$router.replace({
          name: 'requests.list-page'
        })
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    isEmptyObj(obj) {
      return isEmpty(obj)
    }
  },

  async mounted() {
    await this.fetchRequest()
  }
}
</script>
<style lang="scss" scoped>
.file-details {
  height: auto;
  padding: 0 10vw;
}

.card {
  border-radius: 8px;
  opacity: 1;
  margin: 0;
}

.preview {
  width: 1440px;
  height: 808px;

  @media (max-width: 767px) {
    display: none;
  }
}

.preview-container {
  height: 192px;
  flex-wrap: nowrap;

  @media (max-width: 767px) {
    width: auto;
  }
}

.files {
  height: 192px;
}

.image {
  margin: 0 !important;
  max-height: 100%;
}

.list {
  justify-content: space-around;
}

.upload-details {
  padding-right: 0;

  @media (max-width: 767px) {
    padding-left: 0;
    padding-top: 1.5rem;
  }
}
</style>
